export default "__VITE_ASSET__BvtuYoWh__"